import { useState } from "react";

export const Input = ({ onFocus, type, placeholder, label, value, onChange, width, required }) => {
    const [focus, setFocus] = useState(false);
    const handleFocus = () => {
        setFocus(true);
        if (onFocus) {
            onFocus(); // Call the custom function if provided
        }
    };
    return (
        <div className={`${width ? width : "w-full"} relative p-2`}>
            <label
                className={`${
                    focus || value ? "top-2 text-[10px]" : "top-5"
                } transition-all absolute left-4 text-shade-dark`}
            >
                {placeholder}
            </label>
            <input
                required={required}
                className={`relative w-full outline-none rounded p-2 py-3 border border-shade-dark bg-transparent`}
                value={value}
                onChange={onChange}
                onFocus={handleFocus}
                // onFocus={() => setFocus(true)} // Set the state when the input is focused
                onBlur={() => setFocus(false)} // Reset the state when the input loses focus
                type={type}
            />
        </div>
    );
};

export const Checkbox = ({ checked, label, required }) => {
    return (
        <div>
            <label className="flex p-2">
                <input required={required} className="accent-slate-900 w-4" type="checkbox" />
                <p className="pl-2 text-sm text-shade-dark">{label}</p>
            </label>
        </div>
    );
};
